import './bootstrap';

import {
    Chart,
    BarController,
    BarElement,
    RadarController,
    PointElement,
    LineElement,
    Filler,
    CategoryScale,
    LinearScale,
    RadialLinearScale,
    Tooltip,
    Legend
} from 'chart.js';

Chart.register(
    BarController,
    BarElement,
    RadarController,
    PointElement,
    LineElement,
    Filler,
    CategoryScale,
    LinearScale,
    RadialLinearScale,
    Tooltip,
    Legend
);

window.Chart = Chart;